import { render, staticRenderFns } from "./PageSettings.vue?vue&type=template&id=2cbc1220"
import script from "./PageSettings.vue?vue&type=script&lang=js"
export * from "./PageSettings.vue?vue&type=script&lang=js"
import style0 from "./PageSettings.vue?vue&type=style&index=0&id=2cbc1220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports